const reviews = [
  {
    author: "Jean",
    grade: 4,
    comment: "common.reviews.list.0.comment",
  },
  {
    author: "Asgrim",
    grade: 5,
    comment: "common.reviews.list.1.comment",
  },
  {
    author: "bielas",
    grade: 4,
    comment: "common.reviews.list.2.comment",
  },
  {
    author: "SUKESH",
    grade: 4,
    comment: "common.reviews.list.3.comment",
  },
  {
    author: "Jean",
    grade: 4,
    comment: "common.reviews.list.0.comment",
  },
  {
    author: "Asgrim",
    grade: 5,
    comment: "common.reviews.list.1.comment",
  },
  {
    author: "bielas",
    grade: 4,
    comment: "common.reviews.list.2.comment",
  },
  {
    author: "SUKESH",
    grade: 4,
    comment: "common.reviews.list.3.comment",
  },
];

export default reviews;
